/** @jsx jsx */
import React, { Fragment, useState } from 'react'
import { jsx, Box, Flex, Text, Grid } from 'theme-ui'
import styled from '@emotion/styled'

import ProductPageHeader from '../product/ProductPageHeader'
import ProductImageCarousel from '../shared/Carousel/ProductImageCarousel'
import Img from 'gatsby-image'
import IconTextBlock from '../footer/IconTextBlock'

import { useWindowSize } from '../../hooks/useWindowSize'
import ProductHeading from '../product/ProductHeading'
import { Tag } from '../TagList'
import Hero from './Hero'

const Wrapper = styled(Flex)`
  position: relative;
  height: auto;
  justify-content: flex-start;
  flex-wrap: wrap;
`

const wrapperStyle = {
  width: '100%',
  height: '100%',
  verticalAlign: 'bottom',
}

export const getOverlayTag = tags => {
  const tag = tags.find(i => i.startsWith('overlay_'))
  return tag ? tag.slice(8).replace(/-/g, ' ') : null
}

export const NewTag = ({ smallTag, text }) => {
  return (
    <Tag
      sx={{
        bg: 'black',
        position: 'absolute',
        mr: 'auto',
        ml: 'auto',
        zIndex: 4,
        top: smallTag ? [10, null, 15] : [15, null, 25],
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        width: 'auto',
        borderRadius: 0,
        height: smallTag ? ['18px', null, '20px'] : ['25px', null, '40px'],
        px: smallTag ? ['8px', null, '6px'] : ['10px', null, '12px'],
        color: 'white',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        lineHeight: 'normal',
        fontWeight: 900,
        fontSize: smallTag ? ['7px', null, null, null, null, 0] : [0, null, 3],
        verticalAlign: 'middle',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {text}
    </Tag>
  )
}
const ProductHero = ({ ...props }) => {
  const { smallScreen, mobile } = useWindowSize()
  const [productInfo, setProductInfo] = useState({})

  const carouselImages = props.images.map((i, k) => {
    return (
      <Img
        sx={wrapperStyle}
        fluid={i.localFile.childImageSharp.fluid}
        alt={i.title}
        sx={{ pointerEvents: ['none', 'none', 'auto'] }}
      />
    )
  })

  const finestVideo =
    props.metafields && props.metafields.find(i => i.key === 'finest_video')

  if (finestVideo) {
    carouselImages.push(
      <video sx={wrapperStyle} autoPlay muted loop playsInline id="video">
        <source type="video/mp4" src={finestVideo.value} alt="video" />
      </video>
    )
  }

  const productVideoUrl = props.details && props.details.productVideo

  return (
    <>
      {props.images && (
        <Wrapper
          sx={{
            width: '100%',
          }}
        >
          {smallScreen && (
            <ProductHeading
              loaded={productInfo.loaded}
              currentValue={productInfo.currentValue}
              currentPrice={productInfo.currentPrice}
              currentCompareAtPrice={productInfo.currentCompareAtPrice}
              convertedCurrency={productInfo.convertedCurrency}
              title={props.title}
              avgScore={props.avgScore}
              executeScroll={props.executeScroll}
              numberOfBusinessReviews={props.numberOfBusinessReviews}
              styles={{ margin: mobile ? '20px 20px 10px 20px' : '20px 0px' }}
              primaryTag={props.primaryTag}
              secondaryTag={props.secondaryTag}
            />
          )}
          <Box
            sx={{
              width: ['100%', '100%', '100%', '100%', '66%'],
            }}
          >
            {mobile ? (
              <ProductImageCarousel tags={props.tags} slides={carouselImages} />
            ) : (
              <Flex
                sx={{
                  flexWrap: 'wrap',
                  display: ['none', 'flex', 'flex'],
                }}
              >
                {props.images.map((i, k) => {
                  return (
                    <Box sx={{ width: '50%', p: '3px' }}>
                      {' '}
                      <Img
                        sx={wrapperStyle}
                        fluid={i.localFile.childImageSharp.fluid}
                        alt={i.title}
                        sx={{
                          pointerEvents: ['none', 'none', 'auto'],
                        }}
                        key={k}
                      />
                    </Box>
                  )
                })}

                {finestVideo && (
                  <video
                    sx={wrapperStyle}
                    autoPlay
                    muted
                    loop
                    playsInline
                    id="video"
                    sx={{ width: '50%', p: '3px' }}
                  >
                    <source
                      type="video/mp4"
                      src={finestVideo.value}
                      alt="video"
                    />
                  </video>
                )}
                {productVideoUrl && (
                  <Box
                    sx={{
                      width: '100%',
                    }}
                  >
                    <Hero
                      sx={{ p: '3px' }}
                      videoContainterStyle={{
                        px: 0,
                      }}
                      backgroundVideoUrl={productVideoUrl}
                      inline={true}
                    />
                  </Box>
                )}
              </Flex>
            )}
          </Box>
          <Box
            sx={{
              width: ['100%', '100%', null, null, '32%'],
              pl: [0, 0, null, null, 35],
              p: [15, 15, 0],
              pt: [10, 15, 0],
            }}
          >
            <ProductPageHeader
              {...props}
              setProductInfo={info => {
                setProductInfo(info)
              }}
            />
          </Box>
        </Wrapper>
      )}
    </>
  )
}

export default ProductHero
